/* eslint-disable @angular-eslint/no-input-rename */

import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnChanges } from '@angular/core';
import { CdkAccordionItem } from '@angular/cdk/accordion';
import { MatExpansionPanelState } from '@angular/material/expansion';

const bodyExpansion = trigger('bodyExpansion', [
    state('collapsed, void', style({ height: '0px', visibility: 'hidden' })),
    state('expanded', style({ height: '*', visibility: 'visible' })),
    transition('expanded <=> collapsed, void => collapsed', animate('225ms cubic-bezier(0.4, 0, 0.2, 1)')),
]);

/** An notification block that functions as and extends CDK's expandable functionality.  */
@Component({
    selector: 'of-inline-notification',
    templateUrl: './inline-notification.component.html',
    styleUrls: ['./inline-notification.component.scss'],
    animations: [bodyExpansion],
    standalone: false
})
export class InlineNotificationComponent extends CdkAccordionItem {
  /** The title that will appear at the top of the notification. */
  @Input('titleText') titleText = '';
  /** The url of the image that will appear on the side of the notification. */
  @Input('srcUrl')    srcUrl = '';
  /** The alt text for the image on the side of the notification. */
  @Input('altText')   altText = '';

  /** Expand the component in to an open state. */
  open() {
    if (this.expanded) {
      // Add a --needs-attention class
    } else {
      super.open();
    }
  }

  /** Return `expanded` or `collapsed` depending on the expandable status. */
  getExpandedState(): MatExpansionPanelState {
    return this.expanded ? 'expanded' : 'collapsed';
  }
}
